import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

export type TomVendingSiteVisitSession = {
  id: number;
  visitDate: string;
  visitStatus?: string;
  locationTomVending?: { id: number; name?: string | null } | null;
};

export async function startOrGetTomVendingSiteVisit(
  locationTomVendingId: number,
  visitDate?: string,
): Promise<{ siteVisit: TomVendingSiteVisitSession; visitDate: string; countCalendarTimeZone?: string }> {
  const body: { visitDate?: string; locationTomVendingId: number } = {
    locationTomVendingId,
  };
  if (visitDate?.trim()) {
    body.visitDate = visitDate.trim();
  }
  const response = await httpClient.post('api/tom-vending/site-visit/start-or-get', body);
  const d = response.data as {
    siteVisit: TomVendingSiteVisitSession;
    visitDate?: string;
    countCalendarTimeZone?: string;
  };
  return {
    siteVisit: d.siteVisit,
    visitDate: d.visitDate ?? d.siteVisit.visitDate,
    countCalendarTimeZone: d.countCalendarTimeZone,
  };
}

export async function setTomVendingSiteVisitLocation(
  siteVisitId: number,
  locationTomVendingId: number,
): Promise<TomVendingSiteVisitSession> {
  const response = await httpClient.post('api/tom-vending/site-visit/set-location', {
    id: siteVisitId,
    locationTomVendingId,
  });
  return (response.data as { siteVisit: TomVendingSiteVisitSession }).siteVisit;
}

export async function finalizeTomVendingSiteVisit(
  siteVisitId: number,
): Promise<TomVendingSiteVisitSession> {
  const response = await httpClient.post('api/tom-vending/site-visit/finalize', {
    id: siteVisitId,
  });
  const d = response.data as { success?: boolean; siteVisit: TomVendingSiteVisitSession };
  return d.siteVisit;
}
